import TextField, { TextFieldProps } from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

export const StandardTextField = styled(TextField)<TextFieldProps>(() => ({
  marginBottom: 8,
  "& .MuiOutlinedInput-root": {
    minHeight: 52,
    backgroundColor: "#FFFFFF",
  },
}));
